import React from 'react'

import { AppLocale } from '@procsea/common/utils'
import { ContextualMenu, MenuEntry, MenuSection } from '@procsea/design-system'

import LanguageMenuItem from './LanguageMenuItem'
import { APP_LANGUAGES } from './appLanguages'

const LanguagesContextMenu = () => (
  <ContextualMenu
    button={
      <MenuEntry
        config={{ disableActiveState: true }}
        data-e2e="menu-entry-language"
        icon="language"
        label={gettext('Language')}
        hasChevron
      />
    }
    data-e2e="language-context-menu"
    placement="right"
    fallbackPlacements={['left', 'auto']}
  >
    <MenuSection>
      {Object.keys(APP_LANGUAGES).map(locale => (
        <LanguageMenuItem key={locale} locale={locale as AppLocale} />
      ))}
    </MenuSection>
  </ContextualMenu>
)

export default LanguagesContextMenu
